// @ts-nocheck
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Collapse } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { getSidebarThemeStyle } from '../_config/utils';
import { renderSidebarMenuIcon } from './sidebarMenuRegistry.js';

const SIDEBAR_FAVORITE_STAR_COLOR = '#FFC107';

export const sidebarStyles = {
  icon: {
    fontSize: 23,
    width: 23,
  },
  iconSmall: {
    fontSize: 20,
    width: 20,
  },
  iconBig: {
    fontSize: 24,
    width: 24,
  },
  sidebar: {
    paddingBottom: 70,
    paddingTop: 0,
  },
};

export const SidebarNavContext = React.createContext({
  searchQuery: '',
  sidebarFavorites: [],
  onToggleFavorite: () => {},
  registerMenuIcon: () => {},
});

export function menuItemMatchesQuery(searchLabel, menuId, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) {
    return true;
  }
  const label = (searchLabel || '').toLowerCase();
  const id = (menuId || '').toLowerCase();
  return label.indexOf(q) !== -1 || id.indexOf(q) !== -1;
}

export function resolveSidebarSearchLabel({ searchLabel, entityKey, menuId, title }) {
  if (searchLabel) {
    return searchLabel;
  }
  if (entityKey) {
    return L20NContext.getSync(entityKey);
  }
  if (typeof title === 'string') {
    return title;
  }
  return menuId || '';
}

export const MenuItemRenderer = ({ dispatch, item, emptyItem, renderCondition }) => {
  if (renderCondition) {
    return item;
  }
  return (emptyItem || <span />);
};

export class MenuItem extends React.Component {
  componentDidMount() {
    this.registerIcon();
  }

  componentDidUpdate() {
    this.registerIcon();
  }

  registerIcon() {
    const { registerMenuIcon, menuId, path, icon } = this.props;
    const resolvedMenuId = menuId || path;
    if (registerMenuIcon && resolvedMenuId && icon) {
      registerMenuIcon(resolvedMenuId, icon);
    }
  }

  render() {
    const {
      isSelected,
      title,
      icon,
      onClick,
      iconStyle,
      containerStyle,
      menuId,
      path,
      searchLabel,
      entityKey,
      hidden: hiddenProp,
      showFavoriteControl,
      iconKey,
    } = this.props;

    const {
      searchQuery,
      sidebarFavorites,
      onToggleFavorite,
    } = this.context;

    const resolvedMenuId = menuId || path;
    const resolvedSearchLabel = resolveSidebarSearchLabel({
      searchLabel,
      entityKey,
      menuId: resolvedMenuId,
      title,
    });
    const hidden = hiddenProp === true
      || !menuItemMatchesQuery(resolvedSearchLabel, resolvedMenuId, searchQuery);
    const isFavorite = (sidebarFavorites || []).some(item => item.menuId === resolvedMenuId);

    if (hidden) {
      return null;
    }

    return (
      <div
        className={`sidebar-row ${isSelected ? 'sidebar-row-active' : ''}`}
        style={{ ...containerStyle }}
        data-menu-id={resolvedMenuId}
        data-sidebar-search-label={resolvedSearchLabel}
      >
        <ListItem
          button
          selected={isSelected}
          style={{ borderRadius: 5, height: 50, margin: 0, padding: 0, paddingLeft: 15, paddingRight: showFavoriteControl ? 0 : undefined }}
          onClick={() => onClick()}
        >
          {icon ? (
            <ListItemIcon
              className={`sidebar-row-icon ${isSelected ? 'sidebar-row-icon-active' : ''}`}
              style={{ ...iconStyle }}
            >
              {icon}
            </ListItemIcon>
          ) : null}
          <h4 className={`sidebar-row-text ${isSelected ? 'sidebar-row-text-active' : ''}`}>{title}</h4>
          {showFavoriteControl && resolvedMenuId ? (
            <IconButton
              size="small"
              aria-label={isFavorite ? 'remove favorite' : 'add favorite'}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                if (onToggleFavorite) {
                  onToggleFavorite({
                    menuId: resolvedMenuId,
                    path: path || resolvedMenuId,
                    iconKey: iconKey || entityKey || resolvedMenuId,
                    ...(entityKey
                      ? { entityKey }
                      : { searchLabel: searchLabel || (typeof title === 'string' ? title : '') || resolvedMenuId }),
                  });
                }
              }}
              style={{ marginLeft: 'auto', marginRight: 4 }}
            >
              {isFavorite ? (
                <StarIcon style={{ color: 'darkorange', fontSize: 20 }} />
              ) : (
                <StarBorderIcon style={{ fontSize: 20, color: '#66788A' }} />
              )}
            </IconButton>
          ) : null}
        </ListItem>
      </div>
    );
  }
}

MenuItem.contextType = SidebarNavContext;

export const CollapsibleMenu = ({
  isOpen,
  headerIcon,
  headerTitle,
  children,
  onToggleOpen,
  headerSearchLabel,
  headerMenuId,
  headerEntityKey,
  entityKey,
}) => {
  const { searchQuery } = React.useContext(SidebarNavContext);
  const resolvedHeaderLabel = resolveSidebarSearchLabel({
    searchLabel: headerSearchLabel,
    entityKey: headerEntityKey || entityKey,
    menuId: headerMenuId,
    title: headerTitle,
  });
  const childArray = React.Children.toArray(children);
  const visibleChildren = childArray.filter(child => child !== null && child !== false);
  const hasVisibleChild = visibleChildren.some(child => child !== null);
  const headerMatches = menuItemMatchesQuery(resolvedHeaderLabel, headerMenuId, searchQuery);
  const queryActive = (searchQuery || '').trim().length > 0;
  const effectiveOpen = isOpen || (queryActive && (headerMatches || hasVisibleChild));

  if (queryActive && !headerMatches && !hasVisibleChild) {
    return null;
  }

  return (
    <div>
      <div className="sidebar-row">
        <ListItem
          button
          onClick={() => onToggleOpen(!isOpen)}
          style={{ borderRadius: 5, height: 50, margin: 0, padding: 0, paddingLeft: 15 }}
        >
          <ListItemIcon className="sidebar-row-icon">
            {headerIcon}
          </ListItemIcon>
          <h4 className="sidebar-row-text" style={{ margin: 0, marginRight: 10 }}>{headerTitle}</h4>
          {effectiveOpen ? <ExpandLess style={{ marginLeft: 'auto', marginRight: 10 }} /> : <ExpandMore style={{ marginLeft: 'auto', marginRight: 10 }} />}
        </ListItem>
      </div>
      <Collapse in={effectiveOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{ paddingLeft: 10 }}>
          {children}
        </List>
      </Collapse>
    </div>
  );
};

export const SidebarSearchField = ({ value, onChange }) => (
  <div
    className="sidebar-search-field"
    style={{ padding: '8px 12px 4px', position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#fff' }}
  >
    <TextField
      fullWidth
      variant="outlined"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      placeholder={L20NContext.getSync('sidebarSearchPlaceholder')}
      inputProps={{ style: { fontSize: 15, padding: '10px 0' } }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ fontSize: 20, color: '#66788A' }} />
          </InputAdornment>
        ),
        style: { minHeight: 40 },
      }}
    />
  </div>
);

export const SidebarFavoritesSection = ({
  favorites,
  location,
  dispatch,
  push,
  getFavoriteIcon,
  classes,
}) => {
  if (!favorites || favorites.length === 0) {
    return null;
  }
  return (
    <div className="sidebar-section" data-sidebar-section="favorites">
      <h5 className="sidebar-header-custom">
        <Entity entity="sidebarFavorites" />
      </h5>
      <hr className="sidebar-separator" />
      {_.map(favorites, (favorite) => {
        const path = favorite.path || favorite.menuId;
        const icon = renderSidebarMenuIcon(favorite.iconKey || favorite.menuId, classes)
          || (getFavoriteIcon ? getFavoriteIcon(favorite.menuId) : null);
        const favoriteTitle = favorite.entityKey
          ? <Entity entity={favorite.entityKey} />
          : (favorite.searchLabel || path);
        return (
          <MenuItem
            key={`favorite-${favorite.menuId}`}
            menuId={favorite.menuId}
            path={path}
            entityKey={favorite.entityKey}
            searchLabel={favorite.entityKey ? undefined : favorite.searchLabel}
            title={favoriteTitle}
            icon={icon}
            isSelected={location && location.pathname && location.pathname === path}
            onClick={() => dispatch(push(path))}
            showFavoriteControl
          />
        );
      })}
    </div>
  );
};

export const SidebarSection = ({ sectionKey, headerEntity, children }) => (
  <div className="sidebar-section" data-sidebar-section={sectionKey}>
    {headerEntity ? (
      <h5 className="sidebar-header-custom">
        <Entity entity={headerEntity} />
      </h5>
    ) : null}
    {headerEntity ? <hr className="sidebar-separator" /> : null}
    {children}
  </div>
);

export const SidebarThemeRoot = ({ themeName, children, className, style }) => (
  <div
    id="sidebar-nav-root"
    className={className}
    style={{ width: '100%', ...getSidebarThemeStyle(themeName), ...style }}
  >
    {children}
  </div>
);
